<template>
  <section class="section--comp">
    <vs-popup fullscreen :active.sync="customIntegrationPopup" title="Request Custom Integration">
      <div class="iframe-container" style="height: 100vh;">
        <iframe src="https://gtbrdd.typeform.com/to/d3N6HE3I" class="w-full h-full border-0"
          style="border: none;" title="Request Custom Integration" frameBorder="0"></iframe>
      </div>
    </vs-popup>
    <div class="container items-center">
      <h3 class="section--h3">App Marketplace</h3>
      <p class="section--p">
        Our technology is distributed as a plug-n-play SaaS and also to develop further via APIs.
      </p>
      <vs-row class="mb-base" vs-type="flex">
        <vs-col
          v-for="(cd, index) in marketplaceList"
          :key="index"
          class="sm:w-full lg:w-1/3 p-3"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <vx-card class="marketplace-card items-left">
            <div>
              <span
                class="p-3 inline-flex feather-icon select-none relative text-primary mr-5"
                style="background: linear-gradient(137.44deg,#fba727 0.01%,#ffd088 103.87%); border-radius: 12px; float: left;"
              >
                <img :src="cd.icon" :alt="cd.title" width="40px" height="40px" />
              </span>
              <div class="p-3">
                  <h4 class="card-title">{{ cd.title }}</h4>
                  <span class="card-subtitle">by {{ cd.manager }}</span>
              </div>
            </div><br>
            <div class="items-left mb-8">
              <p class="card-description">
                {{ cd.shortDescription }}
              </p>
            </div>
            <div v-if="!cd.baseURLDisabled" style="position: absolute; bottom: 1.5rem; right: 1.5rem;">
                  <a :href="`/${cd.baseURL}`" target="_blank" type="flat" class="text-dark mt-4">
                    <span v-if="cd.id=='alex'">Learn More</span>
                    <span v-else>Try Now</span>
                  </a>
            </div>
          </vx-card>
        </vs-col>
        <vs-col
          class="sm:w-full lg:w-1/3 p-3"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <vx-card class="marketplace-card items-left">
            <h4 class="card-title mb-4">Want to build your own integration?</h4>
            <div class="items-left">
              <p class="card-description mb-8">
                What talent solution would you like to build with GetBoarded?
              </p>
            </div>
            <div slot="footer" style="position: absolute; bottom: 1.5rem; right: 1.5rem;">
                  <vs-button @click.stop="customIntegrationPopup=true">Request an App</vs-button>
            </div>
          </vx-card>
        </vs-col>
      </vs-row>
      <!-- <vs-button type="filled" color="#44CC88">View all integrations</vs-button> -->
    </div>
  </section>
</template>

<script>
import marketplaceList from '@/assets/data/marketplace-list.js';
export default {
  name: "AppMarketplace",
  data() {
    return {
      marketplaceList,
      cardData: [
        {
          img: require("../../../../src/assets/images/icons/app-marketplace/editor.svg"),
          title: "Editor",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
          by: 'By GetBoarded'  
        },
        {
          img: require("../../../../src/assets/images/icons/app-marketplace/resume-parser.svg"),
          title: "Resume Parser",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
            by: 'By GetBoarded'  
        },
        {
          img: require("../../../../src/assets/images/icons/app-marketplace/ats.svg"),
          title: "ATS",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
            by: 'By GetBoarded'  
        },
        {
          img: require("../../../../src/assets/images/icons/app-marketplace/alex.svg"),
          title: "ALEX",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
            by: 'By GetBoarded'  
        },
        {
          img: require("../../../../src/assets/images/icons/app-marketplace/dex.svg"),
          title: "DEX",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
            by: 'By GetBoarded'  
        },
        {
          img: require("../../../../src/assets/images/icons/app-marketplace/opex.svg"),
          title: "OPEX",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
            by: 'By GetBoarded'  
        }
      ],
      customIntegrationPopup: false
    };
  },
};
</script>

<style scoped>
.marketplace-card >>> .vx-card__collapsible-content {
  position: initial!important;
}
</style>